import { render, staticRenderFns } from "./live-calendar.vue?vue&type=template&id=20e730b6&scoped=true"
import script from "./live-calendar.vue?vue&type=script&lang=js"
export * from "./live-calendar.vue?vue&type=script&lang=js"
import style0 from "./live-calendar.vue?vue&type=style&index=0&id=20e730b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e730b6",
  null
  
)

export default component.exports